import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ac-type-9-icon',
  templateUrl: './ac-type-9-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AcType9IconComponent {}
